module.exports = "<div class=\"modal-footer\">\n  <button\n    class=\"btn btn-danger pull-left\"\n    ng-click=\"leftPanelCtrl.resetControl()\">\n    <i class=\"fa fa-refresh\"></i>\n    &nbsp;\n    Reset\n  </button>\n  <button\n    class=\"btn btn-success pull-right\"\n    ng-click=\"leftPanelCtrl.updateSpecialControl(); leftPanelCtrl.saveFromEditPanel();\">\n    <i class=\"fa fa-floppy-o\"></i>\n    &nbsp;\n    Save\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dragdropway/components/leftPanel/validEditFooter/edaDragDropWay.leftpanel.validEditFooter.template.html
// module id = 24
// module chunks = 0